import { Component, Input } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-outreach-content-template-modal',
  templateUrl: './outreach-content-template-modal.component.html',
  styleUrls: ['./outreach-content-template-modal.component.scss'],
})
export class OutreachContentTemplateModalComponent {
  @Input() template: string;
  faTimes = faTimes;

  constructor(private modalHelper: NgbModal) {}

  cancel(): void {
    this.modalHelper.dismissAll();
  }
}
